<template>
    <section>

        <div class="page">
            <div>
                <h2>Sending location, event, name card, and file</h2>
                <h3>Sending location, event, name card, and file</h3>
                <ol>
                    <li>Open a chat.</li>
                    <li>Tap “+” next to the text field.</li>
                    <li>Choose what you wish to send:</li>
                    <ol type="a">
                        <li>Choose <strong>Location</strong> to send your location or a nearby place.</li>
                        <li>Choose <strong>Event</strong> to send a new event.</li>
                        <li>Choose <strong>Name Card</strong> to send the information of a contact.</li>
                        <li>Choose <strong>File</strong> to select a file from iCloud Drive or other apps such as Google
                            Drive,
                            Dropbox, Microsoft OneDrive, etc. The maximum allowed file size is 500 MB.
                        </li>
                    </ol>
                    <li>Tap <strong>Send</strong>.</li>
                </ol>
                <h6>Note: In order to send location, event, name card, and file, you will need to grant the app
                    permission to
                    access your iPhone's Location Services, Contacts, Photos and Camera in iPhone Settings >
                    Privacy.</h6>

                <h3>Forwarding location, event, name card, and file</h3>
                <p>To forward location, event, name card or file from one chat to another:</p>
                <ol>
                    <li>Open a chat.</li>
                    <li>Tap and hold type of message you wish to forward, then tap <strong>Forward</strong>.</li>
                    <li>Select any other messages you wish to forward, then tap <strong>Forward</strong> on the bottom
                        right of
                        your screen.
                    </li>
                    <li>Choose the chat you wish to forward the message to then tap <strong>Forward</strong>.</li>
                </ol>
                <h6>Note: When you forward media, documents, locations or contacts, you don't have to upload it again,
                    and therefore it
                    will send faster and use less data.
                </h6>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
